<script>
  import { tourFunctions } from "../tour-functions";
  import { Preloader } from "./preloader";
  import { fly } from "svelte/transition";
  import i18n from "./i18n/i18n";

  // Tooltips
  import Tooltip from "./Tooltip.svelte";
  let showingTooltip = false;
  const showTooltip = () => {
    showingTooltip = true;
  };
  const hideTooltip = () => {
    showingTooltip = false;
  };

  export let tour;
  export let sceneState;
  const preloader = new Preloader(tour);

  export let nextScene = () => {
    tourFunctions.nextSceneWithOrder(sceneState.currentOrder);
    preloader.preloadCurrentScene();
  };

  export let hideLast = false;

  let sceneIndex = tourFunctions.currentScene.getIndex();
  addEventListener("krpano:newpano", () => {
    sceneIndex = tourFunctions.currentScene.getIndex();
  });
</script>

{#if !hideLast || sceneIndex < tourFunctions.totalScenes - 1}
  <button
    class="next"
    on:click={nextScene}
    transition:fly={{ x: 300, duration: 500 }}
    on:mouseenter={showTooltip}
    on:mouseleave={hideTooltip}
    aria-label={$i18n.t('tour.nextScene')}
  >
    <Tooltip text={$i18n.t('tour.nextScene')} {showingTooltip} position={"left"} />
    <div class="icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.71 32.59"
        ><polyline
          points="18.68 1.11 2.21 16.18 18.68 31.49"
          style="fill:none;stroke:var(--next-scene-text-color);stroke-miterlimit:10;stroke-width:2px"
        /></svg
      >
    </div>
  </button>
{/if}

<style>
  :root {
    --next-scene-bg-color-rgb: var(--theme-color-rgb);
    --next-scene-text-color: var(--controls-text-color);
  }

  button {
    background: rgba(var(--next-scene-bg-color-rgb), 0.8);
    color: white;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    border-radius: 10px 0 0 10px;
    cursor: pointer;
    padding: 20px 10px 20px 20px;
    border: none;
  }

  button:hover {
    background: rgba(var(--next-scene-bg-color-rgb), 1);
    border: 3px solid var(--next-scene-text-color);
    border-width: 3px 0 3px 3px;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: 35px;
    height: 35px;
    transform: scaleX(-1);
  }
</style>
